module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-700italic.ba136d97.woff2";